import { ref } from "vue";
import { GroupNode } from "@/models/groupNode";
import { de } from "vuetify/lib/locale/index.mjs";
import {
  SortTableKey,
  Sort,
  group,
  sortItems,
  sortByContractDate,
  sortByInstrument,
} from "./groupLogic.pure";

export type { SortTableKey, Sort };

export function useGroupingHook<T extends object>() {
  const isOpenStates = ref<Record<string, boolean>>({});

  function extractExpandedIDs(
    grouped: GroupNode<T>[] | T[],
    expandedIDs: Record<string, any> = {}
  ): Record<string, boolean> {
    if (Array.isArray(grouped)) {
      grouped.forEach((group) => {
        if ("key" in group) {
          expandedIDs[String(group.key)] =
            isOpenStates.value[(group as GroupNode<T>).key as string] ??
            (group as GroupNode<T>).isOpen;

          if (Array.isArray((group as GroupNode<T>).items)) {
            extractExpandedIDs((group as GroupNode<T>).items, expandedIDs);
          }
        }
      });
    }
    return expandedIDs;
  }

  function setRowOpenState(id: string, value: boolean) {
    isOpenStates.value[id] = value;
  }

  return {
    group,
    sortItems,
    sortByContractDate,
    sortByInstrument,
    extractExpandedIDs,
    isOpenStates,
    setRowOpenState,
  };
}
